import messages from '../../../locale/messages';
import valid from 'card-validator';

const validate = (values, props) => {

  const errors = {};

  //#region Message
  /* if (!values.message) {
    errors.message = messages.required;
  } else if (values.message && values.message.toString().trim() == '') {
    errors.message = messages.required;
  } */
  //#endregion

  /* if (values.paymentType == 1 && !values.paymentCurrency) {
    errors.paymentCurrency = messages.required;
  } */

  if( !props.isAuthenticated ) {
    if (!values.name || values.name.trim() == '') {
      errors.name = messages.required;
    }
    if (!values.email || values.email.trim() == '') {
      errors.email = messages.required;
    } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,6}$/i.test(values.email)) {
      errors.email = messages.emailInvalid;
    }
  }

  //#region BACS bank details
  /* if( props.monthlyPass ) {
    let bankAccountNumberTrimmed, bankAccountSortCodeTrimmed, bankAccountHolderNameTrimmed;
    if( !values.bankAccountNumber || (bankAccountNumberTrimmed = values.bankAccountNumber.toString().trim()) == '' ) {
      errors.bankAccountNumber = messages.required;
    }
    else if( !/^\d{4,10}$/g.test(values.bankAccountNumberTrimmed) ) {
      errors.bankAccountNumber = messages.invalid;
    }
    
    if( !values.bankAccountSortCode || (bankAccountSortCodeTrimmed = values.bankAccountSortCode.toString().replace(/[\s\-]/g, '')) == '' ) {
      errors.bankAccountSortCode = messages.required;
    }
    else if( !/^\d{6}$/g.test(bankAccountSortCodeTrimmed) ) {
      errors.bankAccountSortCode = messages.invalid;
    }
    
    if( !values.bankAccountHolderName || (bankAccountHolderNameTrimmed = values.bankAccountHolderName.toString().trim()) == '' ) {
      errors.bankAccountHolderName = messages.required;
    }
    else if( bankAccountHolderNameTrimmed.length > 64 ) {
      errors.bankAccountHolderName = messages.maxLength64Characters;
    }

    return errors;
  } */
  //#endregion

  if( !props.monthlyPass && !props.isExpressCheckout ) {
    if (!values.name) {
      errors.name = messages.required;
    } else if (values.name && values.name.toString().trim() == '') {
      errors.name = messages.required;
    }

    if (!values.cardNumber) {
      errors.cardNumber = messages.required;
    } else {
      var numberValidation = valid.number(values.cardNumber);
      if (!numberValidation.isValid) {
        errors.cardNumber = messages.invalid;
      }
    }

    if (!values.expiryDate) {
      errors.expiryDate = messages.required;
    } else {
      var monthValidation = valid.expirationMonth(values.expiryDate);
      if (!monthValidation.isValid) {
        errors.expiryDate = messages.invalid;
      }
    }

    if (!values.expiryYear) {
      errors.expiryYear = messages.required;
    } else {
      var yearValidation = valid.expirationYear(values.expiryYear);
      if (!yearValidation.isValid) {
        errors.expiryYear = messages.invalid;
      }
    }

    if (!values.cvv) {
      errors.cvv = messages.required;
    } else {
      var maximumLength = 3;
      var numberValidation = valid.number(values.cardNumber);
      if (values.cardNumber && numberValidation.isValid) {
        var cardType = valid.number(values.cardNumber);
        if (cardType.card.type === 'american-express') {
          maximumLength = 4;
        }
      }
      var cvvValidation = valid.cvv(values.cvv, maximumLength);
      if (!cvvValidation.isValid) {
        errors.cvv = messages.invalid;
      }
    }

    if( !values.zipcode || values.zipcode.trim() == '' ) {
      errors.zipcode = messages.required;
    }
  }

  return errors;
}

export default validate;


// WEBPACK FOOTER //
// src/components/Booking/Payment/validate.js